export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            关于暗网吃瓜
          </h2>
        </div>

        <div className="bg-background-200 rounded-2xl p-6 md:p-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary-500/15 flex items-center justify-center">
              <span className="font-brand text-3xl text-primary-400">暗</span>
            </div>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              暗网吃瓜成立于2023年，是国内领先的暗网吃瓜论坛和吃瓜群聚合平台。我们致力于为吃瓜群众提供一个真实、快速、深度的爆料交流社区。
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              不同于传统娱乐资讯平台，暗网吃瓜坚持「用户驱动内容」的社区模式。来自各行各业的匿名爆料人、资深吃瓜群众和真相追踪者在这里汇聚，通过黑料讨论和交叉验证，还原事件全貌。
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6">
              我们的暗网吃瓜论坛每天产生8500+条新帖，吃瓜群覆盖全国300+城市，已成为中文互联网最具影响力的真实吃瓜和隐秘八卦交流阵地。无论是娱乐圈、科技圈还是社会热点，新爆料第一时间抵达，吃瓜速递永不停歇。
            </p>

            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
              <div>
                <div className="text-2xl font-bold text-accent-400 font-heading">8500+</div>
                <div className="text-xs text-foreground-500 mt-1">日均新帖</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div>
                <div className="text-2xl font-bold text-accent-400 font-heading">300+</div>
                <div className="text-xs text-foreground-500 mt-1">城市覆盖</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div>
                <div className="text-2xl font-bold text-accent-400 font-heading">320万+</div>
                <div className="text-xs text-foreground-500 mt-1">注册用户</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div>
                <div className="text-2xl font-bold text-accent-400 font-heading">24h</div>
                <div className="text-xs text-foreground-500 mt-1">审核响应</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}